import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const style: CSSResult = css`
    .back-in-stock-notification {
        display: flex;
        flex-direction: column;
        gap: ${csSpacing.spacing05};
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: ${csSpacing.spacing07}
    }
`
